import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { initSentry, isSentryEnabled, Sentry } from './sentry.js'

initSentry()

const rootEl = document.getElementById('root')
if (!rootEl) {
  document.body.innerHTML = '<div style="padding:20px;font-family:system-ui;">Error: #root not found.</div>'
} else {
  const placeholder = rootEl.querySelector('#app-loading')
  if (placeholder) placeholder.remove()

  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <Sentry.ErrorBoundary
        fallback={({ error, componentStack, resetError, eventId }) => (
          <div
            style={{
              padding: '24px',
              textAlign: 'center',
              minHeight: '100vh',
              background: '#f9fafb',
              fontFamily: 'system-ui, sans-serif',
            }}
          >
            <h2 style={{ marginBottom: '8px' }}>Something went wrong</h2>
            <p style={{ color: '#4b5563', marginBottom: '16px' }}>
              {error?.message ?? String(error)}
            </p>
            {import.meta.env.DEV ? (
              <pre
                style={{
                  margin: '0 auto 16px',
                  maxWidth: '960px',
                  padding: '16px',
                  textAlign: 'left',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  background: '#111827',
                  color: '#f9fafb',
                  borderRadius: '8px',
                  fontSize: '13px',
                  lineHeight: 1.5,
                  overflow: 'auto',
                }}
              >
                {[error?.stack, componentStack].filter(Boolean).join('\n\n')}
              </pre>
            ) : null}
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <button
                type="button"
                onClick={resetError}
                style={{
                  padding: '8px 16px',
                  borderRadius: '6px',
                  border: '1px solid #d1d5db',
                  background: '#fff',
                  cursor: 'pointer',
                }}
              >
                Try again
              </button>
              {isSentryEnabled() && eventId ? (
                <button
                  type="button"
                  onClick={() =>
                    Sentry.showReportDialog({
                      eventId,
                      title: 'Something went wrong',
                      subtitle: 'Our team has been notified.',
                      subtitle2: 'Tell us what you were doing when this happened.',
                      labelComments: 'What happened?',
                      labelSubmit: 'Send report',
                      successMessage: 'Thank you — your report was sent.',
                    })
                  }
                  style={{
                    padding: '8px 16px',
                    borderRadius: '6px',
                    border: 'none',
                    background: '#2563eb',
                    color: '#fff',
                    cursor: 'pointer',
                  }}
                >
                  Report this issue
                </button>
              ) : null}
            </div>
          </div>
        )}
      >
        <App />
      </Sentry.ErrorBoundary>
    </React.StrictMode>,
  )
}
